module.exports = __webpack_public_path__ + "img/body_scanner_icon.e63e4e2d.svg";